<template>
  <v-dialog 
    v-model="dialog" 
    max-width="800"
    @click:outside="close_dialog"
  >
    <v-card
      tile
    >
      <v-card-title>เปลี่ยนสถานะ</v-card-title>
      <v-card-text>
        <v-switch
          v-model="form.status"
          color="success"
          :label="`สถานะ: ${form.status == 1 ? 'เปิดรับสมัคร' : 'ปิดรับสมัคร'}`"
        ></v-switch>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="submit">ยืนยัน</v-btn>
        <v-btn class="error" @click="close_dialog">ยกเลิก</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    form: Object
  },
  methods: {
    submit() {
      this.$emit('submit', this.form);
    },
    close_dialog() {
      this.$emit('update:dialog', false);
    }
  }
}
</script>